<script lang="jsx">
import Help from './HelpText'
const focusHandler = ({ e, isPercentage, isDecimal, update }) => {
  const { value } = e.target
  if (!value) {
    return
  }
  if (isPercentage && value.includes('%')) {
    update(value.replace('%', ''))
  } else if (isDecimal && String(value).includes('.00')) {
    const newValue = Number(value).toFixed(0)
    update(isNaN(newValue) ? value : newValue)
  }
}
const blurHandler = ({ e, isPercentage, isDecimal, update }) => {
  const { value } = e.target
  if (!value) {
    return
  }
  let newValue = value
  if (isPercentage && value.includes('.')) {
    newValue = Number(value).toFixed(2)
  } else if (isPercentage && !value.includes('.')) {
    newValue = Number(value).toFixed(0)
  }
  if (isPercentage && !value.includes('%')) {
    update(isNaN(newValue) ? value : newValue + '%')
  } else if (isDecimal) {
    const newValue = Number(value).toFixed(2)
    update(isNaN(newValue) ? value : newValue)
  }
}
const Input = (
  {
    id,
    label,
    icon,
    placeholder,
    value,
    type = 'text',
    update = (x) => x,
    onChange = (x) => x,
    disabled = false,
    required = false,
    isPercentage = false,
    isDecimal = false,
    tabIndex = 1,
    isLoading = false,
  },
  { slots },
) => {
  const input = (
    <input
      type={type}
      id={id}
      placeholder={placeholder}
      tabIndex={tabIndex}
      value={value}
      onFocus={(e) => focusHandler({ e, isPercentage, isDecimal, update })}
      onBlur={(e) => blurHandler({ e, isPercentage, isDecimal, update })}
      onInput={(e) => update(e.target.value)}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      required={required}
    />
  )
  const reqStar = required ? '*' : ''
  return [
    label ? (
      <label for={id}>
        {label + ' ' + reqStar}:{slots.default ? <Help> {slots.default()} </Help> : ''}
      </label>
    ) : (
      ''
    ),

    icon ? (
      <div class="icon-input">
        {input}
        {icon}
      </div>
    ) : (
      input
    ),
    ...[isLoading ? <div class="loading-input">Loading...</div> : null],
  ]
}
export default Input
</script>
